import { IResetPasswordModel } from "@Models/ILoginDetails";
import React, { useContext } from "react";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";
import { Button, Form, Input, Typography } from "antd";
import { BackwardOutlined } from "@ant-design/icons";
import IconButton from "@Components/shared/IconButton";

interface ResetFormProps {
    onResetSubmit: (values: IResetPasswordModel) => Promise<void>;
    onBackSelect: () => void;
    fetching: boolean;
}

const PasswordResetRequestForm: React.FC<ResetFormProps> = (props) => {
    const { ui: uiState } = useContext(MainContext);
    const { Title } = Typography;
    return (
        <div id="login-form">
            <IconButton
                onClick={props.onBackSelect}
                icon={<BackwardOutlined />}
                className="secondary"
                style={{ marginRight: "auto", marginBottom: "20px" }}
            >
                Login
            </IconButton>
            <p
                className="text-center"
                style={uiState.mode === ViewMode.desktop ? { color: "#000" } : { color: "#fff" }}
            >
                Please enter the email you use to log in. We'll send you a password reset.
            </p>
            <Form
                initialValues={{} as IResetPasswordModel}
                requiredMark={false}
                onFinish={async (values: IResetPasswordModel) => {
                    await props.onResetSubmit(values);
                }}
                style={{
                    width: "100%",
                }}
            >
                <Form.Item
                    name="value"
                    required
                    tooltip="This is required"
                    rules={[{ required: true, type: "email", message: "Please enter your email address" }]}
                >
                    <Input placeholder="Email" className="login-item" />
                </Form.Item>
                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={props.fetching}
                        className="submit-button"
                        role="submit-button"
                    >
                        {props.fetching ? null : (
                            <Title level={4} style={{ marginBottom: "0px" }}>
                                Reset password
                            </Title>
                        )}
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};
export default PasswordResetRequestForm;
